import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueRouter from 'vue-router';
import VueHead from 'vue-head';
import router from './router';
import App from './App.vue';
import store from './store';
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);
Vue.use(VueHead);
Vue.use(VueCookies);
Vue.use(VueRouter);

new Vue({
    el: '#app',
    router,
    store,
    ...App,
});
